module.exports = __webpack_public_path__ + "img/nelfund-logo.9e82641f.png";